import React, { FC } from 'react';

import { ButtonLinkWrapper } from '../ButtonLinkWrapper';
import { ButtonContent } from '../Buttons';

interface Props {
  label: string;
  link?: string;
  onClick: () => void;
}

export const SelectorFooter: FC<Props> = ({ label, link, onClick }) => {
  return (
    <ButtonLinkWrapper link={link} onClick={onClick} data-hook="footer-button">
      <ButtonContent label={label} />
    </ButtonLinkWrapper>
  );
};
